import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SEO from './SEO';
import { products } from '../data/products';
import { useLanguage } from '../context/LanguageContext';
import { useTheme } from '../context/ThemeContext';

const Home = () => {
    const { t, language } = useLanguage();
    const { theme } = useTheme();

    return (
        <div className={`${theme === 'dark' ? 'bg-dark-bg' : 'bg-off-white'} min-h-screen pt-24 pb-12`}>
            <SEO
                title="Colección Exclusiva"
                description="Descubre la colección exclusiva de FOIROLA. Moda inspirada en la cultura de Fuengirola. Ediciones limitadas y diseños únicos."
                canonicalPath="/"
            />
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="text-center mb-16"
                >
                    <h1 className={`text-6xl md:text-8xl font-bold ${theme === 'dark' ? 'text-white' : 'text-charcoal'} tracking-tighter mb-4`}>
                        {t('home.collection')}
                    </h1>
                    <p className={`text-xl ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'} font-light tracking-widest uppercase mb-8`}>
                        {t('home.selectStyle')}
                    </p>
                    <div className="max-w-2xl mx-auto">
                        <p className={`${theme === 'dark' ? 'text-gray-400' : 'text-gray-500'} leading-relaxed`}>
                            {t('home.intro')}
                        </p>
                    </div>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    {products.map((product, index) => {
                        // Get translated title if available
                        const title = product.translations && product.translations[language]
                            ? product.translations[language].title
                            : product.title;

                        // Determine image source: 
                        // Use gridImage if available (for Mesias), otherwise check heroAsset (for Navajitas) or default to first image.
                        const imageSrc = product.gridImage
                            ? product.gridImage
                            : (product.id === 'navajitas' && product.heroAsset.type === 'image'
                                ? product.heroAsset.src
                                : product.images[0].src);

                        return (
                            <motion.div
                                key={product.id}
                                initial={{ opacity: 0, y: 50 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: index * 0.2 }}
                                className="group relative aspect-[3/4] overflow-hidden cursor-pointer rounded-lg"
                            >
                                <Link to={`/product/${product.id}`}>
                                    <div className="absolute inset-0 bg-gray-200">
                                        <img
                                            src={imageSrc}
                                            alt={title}
                                            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                                        />
                                    </div>
                                    <div className="absolute inset-0 bg-black/50 group-hover:bg-black/70 transition-colors duration-300" />

                                    <div className="absolute inset-0 flex flex-col justify-center items-center text-white p-8">
                                        <h2 className="text-4xl font-bold tracking-tighter mb-2 transition-all duration-500">
                                            {title.toUpperCase()}
                                        </h2>
                                        <p className="text-sm tracking-widest uppercase transition-all  duration-500">
                                            {t('home.viewDetails')}
                                        </p>
                                    </div>
                                </Link>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default Home;
